/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */

/**
 * Tracks the progression and various phases of an insurance validation process.
 */
export var jove__external_app__v2__validation__model__ValidationStatus;

(function (jove__external_app__v2__validation__model__ValidationStatus) {
  jove__external_app__v2__validation__model__ValidationStatus["IMPORTED"] = "imported";
  jove__external_app__v2__validation__model__ValidationStatus["NOT_STARTED"] = "not_started";
  jove__external_app__v2__validation__model__ValidationStatus["INVITATION_CREATED"] = "invitation_created";
  jove__external_app__v2__validation__model__ValidationStatus["DROPOUT"] = "dropout";
  jove__external_app__v2__validation__model__ValidationStatus["CANCELLED"] = "cancelled";
  jove__external_app__v2__validation__model__ValidationStatus["IN_PROGRESS"] = "in_progress";
  jove__external_app__v2__validation__model__ValidationStatus["FAIL"] = "fail";
  jove__external_app__v2__validation__model__ValidationStatus["SUCCESS"] = "success";
  jove__external_app__v2__validation__model__ValidationStatus["PAYE_CONTRACTOR"] = "paye_contractor";
})(jove__external_app__v2__validation__model__ValidationStatus || (jove__external_app__v2__validation__model__ValidationStatus = {}));